<script setup>
import { ref, computed } from 'vue'

const ASPECT_RATIO_TOLERANCE = 0.05

const props = defineProps({
  image: {
    type: String,
    default: null,
  },
  alt: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'large',
  },
  withBorder: {
    type: Boolean,
    default: true,
  },
})

const sizeClasses = {
  xsmall: 'h-6 rounded-md',
  small: 'h-10 rounded-lg',
  medium: 'h-12 rounded-xl',
  large: 'h-16 rounded-xl',
}

const naturalWidth = ref(null)
const naturalHeight = ref(null)

const isLandscape = computed(() => {
  if (!naturalWidth.value || !naturalHeight.value) {
    return false
  }

  return naturalWidth.value / naturalHeight.value > 1 + ASPECT_RATIO_TOLERANCE
})

const handleLoad = (event) => {
  naturalWidth.value = event.target.naturalWidth
  naturalHeight.value = event.target.naturalHeight
}
</script>

<template>
  <div
    v-if="image"
    class="inline-flex items-center justify-center overflow-hidden border shrink-0 bg-white"
    :class="[
      sizeClasses[size],
      isLandscape ? 'w-auto' : sizeClasses[size],
      withBorder ? 'border-border-light' : 'border-transparent',
    ]"
  >
    <img
      :src="image"
      :alt="alt"
      class="block h-full"
      :class="isLandscape ? 'w-auto object-contain' : 'w-full object-cover'"
      @load="handleLoad"
    />
  </div>
</template>
